var map = {
	"./character.png": 71,
	"./character@2x.png": 72
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 191;



//////////////////
// WEBPACK FOOTER
// ./themes/mf/img ^\.\/character.*\.png$
// module id = 191
// module chunks = 3